import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v2/reports/" });

export const ReportService = {
  getEmployeeWorkReport: async (payload) => {
    try {
      const params = {
        employees: payload.employee?.ids?.length ? payload.employee.ids.join(",") : "all",
        projects: payload.project?.id && payload.project.id !== "All" ? payload.project.id : "all",
        type: payload.type,
        fromDate: payload.date_from,
        toDate: payload.date_to,
      };

      const response = await api.get("employee-works", { params });

      return { status: true, data: response.data };
    } catch (error) {
      console.error("🚀 ~ ReportService ~ getEmployeeWorkReport: ~ error:", error);
      return { status: false };
    }
  },

  getPartyExpenseReport: async (payload) => {
    try {
      const params = {
        parties: payload.party?.id && payload.party.id !== "All" ? payload.party.id : "all",
        projects: payload.project?.id?.id && payload.project.id.id !== "All" ? payload.project.id.id : "all",
        entryBy: payload.entry_by_id?.id && payload.entry_by_id.id !== "All" ? payload.entry_by_id.id : "all",
        type: payload.type,
        fromDate: payload.date_from,
        toDate: payload.date_to,
      };

      const response = await api.get("party-expenses", { params });
      return { status: true, data: response.data };
    } catch (error) {
      console.error("🚀 ~ ReportService ~ getPartyExpenseReport: ~ error:", error);
      return { status: false };
    }
  },

  getProjectReport: async (projects, fromDate, toDate) => {
    try {
      return await api.get(`/project/?projects=${projects}&fromDate=${fromDate}&toDate=${toDate}`);
    } catch (error) {
      console.error(`🔥 ~ file: report.service.js:54 ~ getProjectReport: ~ error:`, error);
    }
  },
};
